<template>
  <div class="vm-text-center">
    <gsp-loader backdrop="false" />
  </div>
</template>

<script setup></script>
